import PropTypes from 'prop-types';
import React, { useState } from 'react';

import StyledLivestreamTeaser from './livestreamTeaser.style';
import Headline from '../../atoms/headline/headline';
import Container from '../../layout/container/container';
import Copy from '../../atoms/copy/copy';
import Iframe from '../../atoms/Iframe/Iframe';
import PlayIcon from '../../icons/play/play';
import Image from '../../atoms/image/image';

const LivestreamTeaser = props => {
  const { headline, subline, copy, iframeSrc } = props;
  const [init, setInit] = useState(false);
  return (
    <StyledLivestreamTeaser {...props}>
      <Container>
        <div className="livestreamTeaser__content">
          <div className="livestreamTeaser__header">
            {subline && (
              <Headline tag="h3" subline className="livestreamTeaser__subline">
                {subline}
              </Headline>
            )}
            <Headline tag="h1" primary className="livestreamTeaser__headline">
              {headline}
            </Headline>
          </div>
          <div className="livestreamTeaser__video-wrapper">
            {!init ? (
              <>
                <button
                  type="button"
                  onClick={() => setInit(true)}
                  className="livestreamTeaser__playButton"
                  label="Start livestream"
                  aria-label="Start livestream"
                >
                  <PlayIcon className="icon" />
                </button>
                <Image src="/static/livestream-poster.jpg" alt="Livestream Poster" lazy="default" />
              </>
            ) : (
              <Iframe file={iframeSrc} />
            )}
          </div>

          {copy && (
            <div className="livestreamTeaser__text">
              <Copy className="livestreamTeaser__copy">{copy}</Copy>
            </div>
          )}
        </div>
      </Container>
    </StyledLivestreamTeaser>
  );
};

LivestreamTeaser.propTypes = {
  iframeSrc: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string,
  copy: PropTypes.string
};

export default LivestreamTeaser;
